module.exports = __webpack_public_path__ + "img/stock1.08006642.png";